import evnetBus from '../event-bus/event-bus'

const eventKeys = {
  loginExpire: 'loginExpire'
}

export const subscribeLoginExpiredEvent = (fn: () => void) => {
  evnetBus.on(eventKeys.loginExpire, fn)
}

export const triggerGotoLoginExpiredEvent = (...args: any) => {
  evnetBus.emit(eventKeys.loginExpire, args)
}
